import script from "./OverlayButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./OverlayButton.vue?vue&type=script&lang=ts&setup=true"

import "./OverlayButton.vue?vue&type=style&index=0&id=7d6b6f87&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d6b6f87"]])

export default __exports__